<template>
    <input
        :id="attributes.formId"
        :type="type"
        :name="attributes.name"
        :tabindex="context.tabindex"
        :aria-labelledby="`${attributes.formId}-label`"
        :placeholder="attributes.placeholder"
        :maxlength="attributes.maxLength"
        :pattern="attributes.regEx"
        class="vue-input"
        v-on="listeners"
        :value="context.element.state.value"
        v-facade="attributes.mask"
        v-bind="elementAttributes">
</template>

<script src="./vue-input-text.js"></script>
